<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>

				<label class="h6 display-block">
					작업일
					<input
						v-model="item.rDate"
						class="input-box radius-10 width-100 mt-10"
						type="date"
					/>
				</label>
				<label class="h6 display-block mt-10">
					작업내용
					<textarea
						v-model="item.report_content"
						class="input-box radius-10 width-100 mt-10"
						placeholder="작업내용 입력하세요"
						lang="ko">
					</textarea>
				</label>

				<label class="display-block mt-10 input-box full-width radius-10">
					<v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file_name }}
					<input
						v-show="false"
						type="file"
						placeholder="대표 이미지"
						class="input-box "
						maxlength="250"
						@change="setFile"
						accept="image/*"
						multiple
					/>
				</label>

				<label
					v-for="(file, f_index) in item.b_file"
					:key="'file_' + f_index"
					class="display-block mt-10 input-box full-width radius-10 justify-space-between"
				>
					<span><v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file.name }}
						</span>

					<button
						@click="removeFile(f_index)"
					>
						<v-icon
							class="color-icon"
						>mdi mdi-close-box</v-icon>
					</button>
				</label>

			</div>

			<h6 class="h6 mt-10">첨부파일</h6>

			<div class="mt-10">
				<ul
					v-if="items_file.length > 0"
				>
					<template
						v-for="file in items_file"
					>
						<li
							:key="'file_' + file.uid"
							class="mb-10 box radius-10 pa-10"
						>
							<img :src="file.file_path" class="object-cover" />

							<div
								v-if="file.file_date"
								class="mt-10"
							>촬영 일시: {{ file.file_date }}</div>
							<div
								v-else
								class="mt-10"
							>촬영일 정보 없음</div>

							<div
								v-if="file.file_gps"
								class="mt-10"
							>
								<a :href="'https://www.google.com/maps?q=' + file.file_gps " target='_blank'>구글 지도에서 보기</a>
							</div>
							<div
								class="mt-10 justify-space-between"
								v-else
							>위치 정보 없음
							<button
								@click="deleteFile(file)"
							><v-icon>mdi mdi-close-box</v-icon></button></div>
						</li>
					</template>
				</ul>
				<Empty
					v-else
				>첨부파일 없습니다</Empty>
			</div>
		</div>
		<div
			class="mt-auto justify-space-between gap-10"
		>
			<button
				class="btn-full btn-primary flex-1"
				@click="putReport('put')"
			>저장</button>
		</div>
	</div>
</template>

<script>

import Empty from "../Layout/Empty";
export default {
	name: 'ProjectReportDetail'
	,
	components: {Empty},
	props: ['user']
	, data: function(){
		return {
			program: {
				name: '작업일지 상세정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {
				report_uid: this.$route.params.idx
			}
			, items_file: []
		}
	}
	, computed: {

		file_name: function(){
			let name = '첨부파일'
			return name
		}
	}
	, methods: {
		putReport: async function(type){
			this.$set(this.item, 'type', type)
			if(this.item.b_file){

				for(let i = 0; i < this.item.b_file.length; i++ ){
					this.$set(this.item, 'b_file' + i, this.item.b_file[i])
				}
				this.$set(this.item, 'file_count', this.item?.b_file.length)
			}
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/putReport'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					this.$bus.$emit('to', { name: 'ProjectTaskView', params: { idx: this.item.task_uid}})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		,setFile: function(e){

			if(!this.item.b_file){
				this.$set(this.item, 'b_file', [])
			}
			if(this.item.b_file){
				for(let i = 0; i < e.target.files.length; i++){
					this.item.b_file.push(e.target.files[i])
				}
			}
		}
		, getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectReport'
					, data: {
						idx: this.item.report_uid
					}
				})

				if(result.success){

					this.item = result.data.report_info
					this.item.report_uid = this.$route.params.idx
					this.items_file = result.data.file_list
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, deleteFile: async function(file){
			try {

				if(confirm("해당 파일을 삭제하시겠습니까?")){
					const result = await this.$request.init({
						method: 'post'
						, url: 'project/deleteFile'
						, data: {
							idx: file.uid
						}
					})

					if(result.success){
						await this.getData()
					}else{
						throw result.message
					}
				}

			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, removeFile: function(f_index){
			this.item.b_file.splice(f_index, 1)
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
		this.getData()
	}
}
</script>